var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.687,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FF6063"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.46 10.226c.22.22.22.576 0 .796L10.335 21.147a.563.563 0 01-.795-.796l10.125-10.125c.22-.22.576-.22.795 0z",
    fill: "#000450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54 10.226c.22-.22.576-.22.795 0L20.46 20.351a.562.562 0 11-.795.796L9.54 11.022a.563.563 0 010-.796z",
    fill: "#000450"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMCAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC42ODY1MjMiIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgcng9IjE1IiBmaWxsPSIjRkY2MDYzIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjAuNDYwMiAxMC4yMjYzQzIwLjY3OTkgMTAuNDQ1OSAyMC42Nzk5IDEwLjgwMjEgMjAuNDYwMiAxMS4wMjE4TDEwLjMzNTIgMjEuMTQ2OEMxMC4xMTU2IDIxLjM2NjQgOS43NTk0MiAyMS4zNjY0IDkuNTM5NzUgMjEuMTQ2OEM5LjMyMDA4IDIwLjkyNzEgOS4zMjAwOCAyMC41NzA5IDkuNTM5NzUgMjAuMzUxM0wxOS42NjQ4IDEwLjIyNjNDMTkuODg0NCAxMC4wMDY2IDIwLjI0MDYgMTAuMDA2NiAyMC40NjAyIDEwLjIyNjNaIiBmaWxsPSIjMDAwNDUwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS41Mzk3NSAxMC4yMjYzQzkuNzU5NDIgMTAuMDA2NiAxMC4xMTU2IDEwLjAwNjYgMTAuMzM1MiAxMC4yMjYzTDIwLjQ2MDIgMjAuMzUxM0MyMC42Nzk5IDIwLjU3MDkgMjAuNjc5OSAyMC45MjcxIDIwLjQ2MDIgMjEuMTQ2OEMyMC4yNDA2IDIxLjM2NjQgMTkuODg0NCAyMS4zNjY0IDE5LjY2NDggMjEuMTQ2OEw5LjUzOTc1IDExLjAyMThDOS4zMjAwOCAxMC44MDIxIDkuMzIwMDggMTAuNDQ1OSA5LjUzOTc1IDEwLjIyNjNaIiBmaWxsPSIjMDAwNDUwIi8+Cjwvc3ZnPgo=";
export { SvgChatClosed as ReactComponent };